import { createTransform } from 'redux-persist';

import { Project, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

export const pruneDeletedProjectModels = createTransform<
  ReduxState['projects'],
  ProjectsState,
  ReduxState
>(
  (projectsState) => {
    const prunedProjectsById: Record<string, Project> = {};
    projectsState.projectIds.forEach((id) => {
      const project = projectsState.projectsById[id];
      if (!project) {
        return;
      }

      const { deletedModelIds, ...modelData } = project.diagram.model.modelData;

      const modelsById = { ...project.modelsById };
      Object.keys(modelsById).forEach((modelId) => {
        if (deletedModelIds?.includes(modelId)) {
          delete modelsById[modelId];
        }
      });

      prunedProjectsById[project.id] = {
        ...project,
        diagram: {
          ...project.diagram,
          model: {
            ...project.diagram.model,
            modelData,
          },
        },
        modelsById,
      };
    });

    return { ...projectsState, projectsById: prunedProjectsById };
  },
  null,
  { whitelist: ['projects'] }
);
